<div
  [style.width.px]="width()"
  [style.height.px]="height()"
  class="card-container"
  [style.background-image]="imgSrcMap[theme()] | ngrxPush"
  [style.background-size]="backgroundSize()"
>
  @if (isActive()) {
    <div class="check-wrapper">
      <rt-icon name="check" size="small-x" colorToken="colorIconOnprimaryDefault" />
    </div>
  }
</div>
<div class="label-container">
  <span class="title">{{ title() }}</span>
  @if (subtitle) {
    <span class="subtitle">&nbsp;{{ subtitle }}</span>
  }
  <div class="icon-help">
    @if (iconHelpTooltip) {
      <rt-icon-help [rtTooltip]="iconHelpTooltip" (click)="$event.stopPropagation()" />
    }
  </div>
</div>
